export default "__VITE_ASSET__nhegJV0T__"